import { HeroEntity, ItemEntity } from '@generated/gql';
import { ITEM_SLOT } from '@shared/constants/items.constant';

export class HeroSlotDialogData {
  slot: ITEM_SLOT;
  equippedItem: ItemEntity | undefined;
  availableItems: ItemEntity[] | undefined;
  hero: HeroEntity;
  isCanUse?: boolean;
}
